import { charts } from "../api/reports.api";

const state = {
	cancelTokens: []
};

const getters = { cancelTokens: (state) => state.cancelTokens };
const actions = {
	async fetch({ commit, dispatch, getters }, source) {
		if (getters.cancelTokens.length) {
			dispatch("cancelRequests");
		}

		const response = await charts.fetch(source);
		return response;
	},
	async fetchApex({ commit, dispatch, getters }, source) {
		if (getters.cancelTokens.length) {
			dispatch("cancelRequests");
		}

		const response = await charts.apexdata(source);
		return response;
	},
	cancelRequests({ commit, state }) {
		state.cancelTokens.forEach((request) => {
			if (request.cancel) {
				request.cancel();
			}
		});
		commit("CLEAR_TOKENS");
	},
	valid: ({}, source) => {
		if (!source) return false;
		return !source.includes("ID}");
	}
};
const mutations = {
	addToken(state, token) {
		state.cancelTokens.push(token);
	},
	CLEAR_TOKENS(state) {
		state.cancelTokens = [];
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
